import React from 'react';
import { useState } from 'react';
import '../../styles/fixed-container.css';
import SelectOptions from '../homePage/SelectOptions';
import CLOSE from '../../images/2723639.png';
import FinishToEmployer from './FinishToEmployer';
import StartNewDay from './StartNewDay';
import Notes from './Notes';

const FixedContainer = (
  {employees,
   vehicles,
   currentContainer, 
   updateemployeesAndvehicles, 
   handleCurrentContainer, 
   handleFinishedOrders,
   notes,
   handleNotes,
   currentOrders,
   assistantPassword,
   percentage
  }) => {
  const [errorMassage, setErrorMassage] = useState('');
  const [updateNotes, setUpdateNotes] = useState(false);

  const handleAddEmployer = (e) => {
    e.preventDefault()  
    let formData = new FormData(e.target);
    const employer =formData.get('employer');
    const vehicle = formData.get('vehicle');
    
    if (!employer && !vehicle) return setErrorMassage('Choose Employee and vehicle');
    if (!employer) return setErrorMassage('Choose Employee');
    if (!vehicle) return setErrorMassage('Choose vehicle');
    if (employer && vehicle) {
      const date = new Date();
      let vehicleName = ''
      let newvehicles = [...vehicles].map((m) => {
        if (m.id === vehicle) {
          m.state = 'on';
          m.employer = employer;
          vehicleName = m.name;
          m.date = date
        }
        return m
      });      
      let newemployees = [...employees].map((e) => {
        if (e.id === employer) {
          e.state = 'on';
          e.vehicle = {name: vehicleName, id:vehicle};
          e.time = [date.getHours(), date.getMinutes()];
          e.date = date
        }
        return e
      });

      handleCurrentContainer('')
      updateemployeesAndvehicles(newemployees, newvehicles)
    }

  }  

  return (
    <section className="fixed-container">
      <div className={`fixed-con ${currentContainer === 'search' ? 'fixed-con-search' : ''}`}>
        <div className='close' onClick={() => handleCurrentContainer('')}>
          <img src={CLOSE} alt='close' />
        </div>
        {currentContainer === 'addEmployer' && <div className='add-employees'>
          <h3>Add Employer</h3>
          {errorMassage && <p className='error-massage'>{errorMassage}</p>}
          <form onSubmit={handleAddEmployer}>
            <div className='form-layer'>
              <select className='choose-em' name='employer' id='employer'>
                <SelectOptions 
                  options={employees} 
                  state='off'
                />
              </select>
              <label htmlFor='employer'>choose employee</label>
            </div>
            <div className='form-layer'>
              <select className='choose-em' name='vehicle' id='vehicle'>
                <SelectOptions 
                  options={vehicles} 
                  state='off'
                />
              </select>
              <label htmlFor='vehicle'>choose vehicle</label>
            </div>
            <button>ADD</button>
          </form>
        </div>}
        {currentContainer === 'finish' && 
        <FinishToEmployer 
          employees={employees}
          vehicles={vehicles}
          handleCurrentContainer={handleCurrentContainer}
          updateemployeesAndvehicles={updateemployeesAndvehicles}
          handleFinishedOrders={handleFinishedOrders}
          assistantPassword={assistantPassword}
          percentage={percentage}
        />
        }

        {currentContainer === 'notes' && 
        <>
        <Notes 
          notes={notes} 
          updateNotes={updateNotes}
          handleNotes={handleNotes}
        />
        <div className='close manage-notes' onClick={() => setUpdateNotes(!updateNotes)}>✎</div>
        </>
        }
        {currentContainer === 'restart' && 
        <StartNewDay 
          assistantPassword={assistantPassword}
          currentOrders={currentOrders}
          employees={employees}
        />
        }
      </div>
    </section>
  )
}

export  default FixedContainer;